// src/utils/routeBuilder.js

// Check if we're building for a specific app deployment
const APP_TYPE = process.env.REACT_APP_TYPE;
const IS_DEVELOPMENT = process.env.NODE_ENV === 'development';

export const buildPath = (path) => {
  // In production build for specific app, remove the prefix
  if (!IS_DEVELOPMENT && APP_TYPE === 'luxottica' && path.startsWith('/luxottica')) {
    return path.replace('/luxottica', '') || '/';
  }
  
  if (!IS_DEVELOPMENT && APP_TYPE === 'iconic' && path.startsWith('/iconic')) {
    return path.replace('/iconic', '') || '/';
  }
  
  // In development or main app build, keep the original path
  return path;
};

export const buildRedirectPaths = (basePath) => {
  // In production build for specific app
  if (!IS_DEVELOPMENT && APP_TYPE === 'luxottica') {
    return {
      ROOT_PATH: '',
      LOGIN: '/login',
      UNAUTHORIZED: '/unauthorized',
      PROJECT_ACCESS_DENIED: '/request-access',
    };
  }
  
  if (!IS_DEVELOPMENT && APP_TYPE === 'iconic') {
    return {
      ROOT_PATH: '',
      LOGIN: '/login',
      UNAUTHORIZED: '/unauthorized',
      PROJECT_ACCESS_DENIED: '/request-access',
    };
  }
  
  // Default paths for main app or development
  return {
    ROOT_PATH: basePath,
    LOGIN: `${basePath}/login`,
    UNAUTHORIZED: `${basePath}/unauthorized`,
    PROJECT_ACCESS_DENIED: `${basePath}/request-access`,
  };
};